import React from 'react';
import Login from './views/usuario/login';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { Provider } from 'react-redux';
import store from './redux/store';
import { 
  UserAgentApplication
} from 'msal';

if (window.location.hash.includes("id_token")) {
  new UserAgentApplication("4ecf3d26-e844-4855-9158-b8f6c0121b50", null, null);
}
console.log(window.location.hash);

function App() {
  return (
      <Router>
        <Provider store={store}>
          <Switch>
            <Route path="/CrolLogin/:salir" component={Login} />
          </Switch>
        </Provider>
      </Router>
  );
}

export default App;
